import React from "react";

const MOTION_PROPS = new Set([
  "initial",
  "animate",
  "exit",
  "transition",
  "whileInView",
  "viewport",
  "whileHover",
  "whileTap",
  "layout",
  "layoutId",
  "variants",
]);

function stripMotionProps(props) {
  const clean = {};
  Object.entries(props).forEach(([key, value]) => {
    if (!MOTION_PROPS.has(key)) {
      clean[key] = value;
    }
  });
  return clean;
}

function createMotionComponent(tagName) {
  const Component = React.forwardRef((props, ref) => {
    const cleanProps = stripMotionProps(props);
    return React.createElement(tagName, { ...cleanProps, ref }, props.children);
  });
  Component.displayName = `Motion.${String(tagName)}`;
  return Component;
}

export const motion = new Proxy(
  {},
  {
    get: (_, tagName) => createMotionComponent(tagName),
  }
);

export function AnimatePresence({ children }) {
  return <>{children}</>;
}
